module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading.summaryIndex) ? _c('vue-spinner') : _c('div', [_c('router-link', {
    staticClass: "btn green",
    attrs: {
      "to": {
        name: 'Report Summary',
        params: {
          reportid: this.$route.params.reportid
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n      Add Summary\n    ")]), _vm._v(" "), _vm._l((_vm.summaryIndex), function(summary) {
    return _c('div', [_c('hr'), _vm._v(" "), _c('p', [_vm._v(_vm._s(summary.name))]), _vm._v(" "), (summary.rows.length > 0) ? _c('vue-good-table', {
      attrs: {
        "columns": _vm.applySortFunctions(summary.columns, summary.id, summary.rows.length),
        "rows": summary.rows,
        "sort-options": {
          initialSortBy: {
            field: summary.initial_sort,
            type: 'asc'
          }
        },
        "id": 'summary-table' + summary.id
      }
    }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "btn green pull-right",
      attrs: {
        "to": {
          name: 'Report Summary',
          params: {
            reportid: _vm.reportId,
            summaryId: summary.id
          }
        },
        "tag": "button"
      }
    }, [_vm._v("\n        Edit\n      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn default pull-right delete-summary",
      on: {
        "click": function($event) {
          return _vm.showDeleteSummaryModal(summary.id)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "summary-delete-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteSummaryConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("DELETE REPORT SUMMARY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Are you sure you would like to delete this summary?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-045a13cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportSummary.vue
// module id = 1538
// module chunks = 1